import { Link } from "react-router-dom";
import { ClosecodeIcon } from "./ClosecodeIcon";

interface LogoProps {
  className?: string;
}

export function Logo({ className = "" }: LogoProps) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`}>
      <ClosecodeIcon size={28} />
      <span className="text-warm-50 font-semibold text-lg">CloseCode</span>
    </Link>
  );
}
